import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import { ace_api } from '@axo/shared/data-access/api';
import { parseUserKey, userKeys } from '../../cache-keys/userKeys';
import { queryFunction } from '../../query-function';

export function useRecentlyOpenedApplications(marketCountry: string, n = 50) {
  const api = useAPI();

  const ctx = useContext(DataAccessContext);
  const clientID = ctx?.state?.user?.clientID ?? '';
  const token = ctx?.state?.user?.token ?? '';

  const cacheKey = userKeys.recentlyOpenedApplications({
    user: clientID,
    country: marketCountry,
  });

  const events = useQuery(
    cacheKey,
    queryFunction(
      ace_api.getRecentlyOpenedApplications(api),
      ({ queryKey }) => {
        const key = parseUserKey(queryKey);
        return {
          ClientID: key.user,
          MarketCountry: key.country,
          Limit: n,
        };
      },
    ),
    {
      enabled: token.length > 0,
    },
  );

  return events?.data ?? [];
}
